import React, { useState } from "react";
import MedicionesList from "./MedicionesList";
import LoadSimple from "../../LoadSimple";
import { capitalizeFirstLetter } from "../../../utils/utils";
import { lang } from "../../generales/traduction";

const TableMediciones = ({
  pageActual,
  limitList,startLimit,
  devices,
  dataList,
  cisSelected,
  setCisSelected,
  registerIsValid,
  searchResults,
  setSearchResults,
  onSearch,
  dataUsers,
  setDataUsers,
  searchTerm,
  setSearchTerm,
  server,
  setRegisterIsValid,
  setData,
  setLoading,
  setError,
  handleChangEdit,
  languaje,
  mode,
  setContRowSelected,
  poolRows,setPoolRows,
  handleShowPopup,
  buscar_cis,
  loadingList,
}) => {
  const [allSelected, setAllSelected] = useState(false);
  setContRowSelected(poolRows.length)
  const rowSelected = (elemento) => {
    if (allSelected) {
      setAllSelected(false)
    }
    setPoolRows((prevRows) => {
      // Busca si el brand_id ya existe en el array
      const exists = prevRows.includes(elemento.brand_id);
      
      // Si existe, filtra para eliminarlo, si no existe, lo agrega
      if (exists) {
        return prevRows.filter(brand_id => brand_id !== elemento.brand_id);
      } else {
        return [...prevRows, elemento.brand_id];
      }
    });
  };
  const handleSelectAll = () => {
    if (allSelected) {
      // Si ya está todo seleccionado, deselecciona todo
      setPoolRows([]);
    } else {
      // Si no, selecciona todos los elementos
      // setPoolRows(dataList
      //   .slice(startLimit, parseInt(pageActual) * parseInt(limitList)));
        // setPoolRows(dataList);
        setPoolRows(dataList.map(item => item.brand_id))
    }
    setAllSelected(!allSelected); // Alterna el estado de seleccionar todo
  };
  return (
    <div className="cont-table-portafolio">
      <div className={"head-table-portafolio"+mode}>
      <div className="compact-head-table-portafolio">
      {/* <div className="field-head-table-mantenimiento field-small">  <div className='cont-checkbox'>
                 <input type='checkbox' className='NotifiCheckBox ' checked={allSelected} style={{height:'15px'}}  onClick={()=>handleSelectAll()} ></input>
                </div></div> */}
        <div className="field-head-table-mantenimiento field-small">  ID</div>
        <div className="field-head-table-mantenimiento field-larger" >{capitalizeFirstLetter(lang[languaje]['marca'])} </div>
        <div className="field-head-table-mantenimiento field-larger" >{capitalizeFirstLetter(lang[languaje]['modelo'])}</div>
        <div className="field-head-table-mantenimiento field-larger" >{capitalizeFirstLetter(lang[languaje]['tipoAgente'])}</div>
        <div className="field-head-table-mantenimiento field-larger" >{capitalizeFirstLetter(lang[languaje]['tipoVariable'])}</div>
        <div className="field-head-table-mantenimiento field-medium" >{capitalizeFirstLetter(lang[languaje]['unidad'])}</div>
        <div className="field-head-table-mantenimiento field-medium" >{capitalizeFirstLetter(lang[languaje]['actualizacion'])}</div>
        <div className="field-head-table-mantenimiento field-larger" >{'OID'}</div>
        <div className="field-head-table-mantenimiento field-larger" >{capitalizeFirstLetter(lang[languaje]['nombreVisible'])}</div>
        <div className="field-head-table-mantenimiento field-medium" >{capitalizeFirstLetter(lang[languaje]['plantillas'])}</div>
        {/* <div className="field-head-table-mantenimiento field-larger" >{'Item'}</div>
        <div className="field-head-table-mantenimiento field-larger" >{capitalizeFirstLetter(lang[languaje]['plantilla'])}</div> */}
        <div className="field-head-table-mantenimiento field-larger" >{capitalizeFirstLetter(lang[languaje]['keyItem'])}</div>
        <div className="field-head-table-mantenimiento field-larger" >{capitalizeFirstLetter(lang[languaje]['acciones'])}</div>
        </div>
      </div>
      <div className="body-table-portafolio">
        {registerIsValid ? (
          <div className="cont-load-user-list">
            <LoadSimple></LoadSimple>
          </div>
        ) : (
          <MedicionesList
            pageActual={pageActual}
             limitList={limitList} startLimit={startLimit}
            dataList={dataList}
            devices={devices}
            cisSelected={cisSelected}
            setCisSelected={setCisSelected}
            searchResults={searchResults}
            setSearchResults={setSearchResults}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            dataUsers={dataUsers}
            setDataUsers={setDataUsers}
            server={server}
            setRegisterIsValid={setRegisterIsValid}
            setData={setData}
            setLoading={setLoading}
            setError={setError}
            handleChangEdit={handleChangEdit}
            languaje={languaje}
            mode={mode}
            setContRowSelected={setContRowSelected}
            rowSelected={rowSelected}
            poolRows={poolRows}
            handleShowPopup={handleShowPopup}
            buscar_cis={buscar_cis}
            loadingList={loadingList}
          ></MedicionesList>
        )}
      </div>
    </div>
  );
};

export default TableMediciones;
